//#region import
import React from 'react';
// custom components
import { Container } from "_atoms";
import { EmptyBookingsList, BookingHistoryList } from "_molecules";

// redux
import { useSelector } from 'react-redux';
import { selectUserDb } from '_redux/slices/main-screen/user';
//#endregion

const BookingHistory = () => {
    const userDb = useSelector(selectUserDb)

    return (
        <div>
            <Container className='p-2' id='container'>

                {/*<CustomTitle title="" subtitle={"Booking History"} description={"A list of all assistance bookings made on behalf of passengers."} backpage={backpage} /> */}

                {/* Bookings List */}
                {userDb ? <BookingHistoryList /> : <EmptyBookingsList />}
            </Container>
        </div>
    );
}

export default BookingHistory;
